import { defineComponent as _defineComponent } from 'vue'
import { Activity, PlantVariety } from 'farmdok-rest-api';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import i18n from '@/initI18n';

import TheContentbar from '@/layout/components/TheContentbar.vue';
import ThePageSkeleton from '@/layout/components/ThePageSkeleton.vue';
import SidebarActivities from '@/map/components/SidebarActivities.vue';
import { ActivityType, Field, Product } from '@/shared/api/rest/models';
import CompanySwitch from '@/shared/components/CompanySwitch.vue';
import DropdownPageOptions from '@/shared/components/DropdownPageOptions.vue';
import FeatureNotAvailable from '@/shared/components/FeatureNotAvailable.vue';
import ProcessOrderSwitch from '@/shared/components/ProcessOrderSwitch.vue';
import ButtonDropdown from '@/shared/components/buttons/ButtonDropdown.vue';
import { Data } from '@/shared/mixins/store/types';
import { availableFeatures } from '@/shared/storeDynamicFeatures';
import store from '@/store';
import { RootState } from '@/store/types';

import ModalPageSettingsContainer from '../activities/containers/table/ModalPageSettingsContainer.vue';
import ActivitiesMapContainer from './containers/ActivitiesMapContainer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageActivitiesMap',
  setup(__props) {

const router = useRouter();
const $t = i18n.translate;
const sidebarActivities = ref();
const modalPageSettings = ref();

const buttonUpdateSelection = [
  {
    text: $t('Auswahl aufheben'),
    handler: () => sidebarActivities.value.$refs.tableContainer.$refs.table.selectAllVisible(false),
  },
  {
    text: $t('Auswahl umkehren'),
    handler: () => sidebarActivities.value.$refs.tableContainer.$refs.table.invertSelection(),
  },
  {
    text: $t('Alle auswählen'),
    handler: () => sidebarActivities.value.$refs.tableContainer.$refs.table.selectAllVisible(true),
  },
];

/* LIFECYCLE */

onMounted(() => {
  store.dispatch('activities/subscribe');
  store.dispatch('activityTypes/subscribe');
  store.dispatch('fields/subscribe');
  store.dispatch('varieties/subscribe');
  store.dispatch('products/crops/subscribe');
});

/* COMPUTED */

const currentCompaniesHaveFeature = computed<{ enabled: boolean; readonly: boolean; visible: boolean }>(() =>
  store.getters.currentCompaniesHaveFeature(availableFeatures.FEATURE_ACTIVITIES),
);

const mapFeatureEnabled = computed<boolean>(
  () =>
    store.getters.currentCompaniesHaveFeatureEnabled(availableFeatures.FEATURE_MAP) &&
    store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_MAP),
);
const mapFeatureVisible = computed<boolean>(() =>
  store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_MAP),
);

const loading =
  computed<boolean>(() => store.getters['activities/loading'] || store.getters['fields/loading']) ||
  store.getters['varieties/loading'] ||
  store.getters['products/crops/loading'] ||
  store.getters['activityTypes/loading'];

const fields = computed<Data<Field>>(() => (store.state as RootState).fields.data);

const varieties = computed<Data<PlantVariety>>(() => (store.state as RootState).varieties.data);
const crops = computed<Data<Product>>(() => (store.state as RootState).products.crops.data);
const activities = computed<Data<Activity>>(() => (store.state as RootState).activities.data);
const activityTypes = computed<Data<ActivityType>>(() => (store.state as RootState).activityTypes.data);

const selectedActivityIds = computed<string[]>(() => store.getters['activities/selectedActivityIds']);

function onShowSettings() {
  modalPageSettings.value?.show();
}

return { __sfc: true,router, $t, sidebarActivities, modalPageSettings, buttonUpdateSelection, currentCompaniesHaveFeature, mapFeatureEnabled, mapFeatureVisible, loading, fields, varieties, crops, activities, activityTypes, selectedActivityIds, onShowSettings, TheContentbar, ThePageSkeleton, SidebarActivities, CompanySwitch, DropdownPageOptions, FeatureNotAvailable, ProcessOrderSwitch, ButtonDropdown, ModalPageSettingsContainer, ActivitiesMapContainer }
}

})